import { createAsyncSaga } from '@wahaaabello/redux-async-actions';
import { Action } from 'redux-actions';
import { all, call, put, takeLatest } from 'redux-saga/effects';
import { AnyObject } from 'types';
import * as api from '../../../api';
import formsActions from './actions';

function* fetchForm({
  payload
}: Action<string | (AnyObject & { formid: string })>) {
  let formid;
  let others: AnyObject = {};
  if (typeof payload === 'object') {
    ({ formid, ...others } = payload);
  } else {
    formid = payload;
  }
  try {
    const formInfo = yield call(api.fetchForm, { formid, ...others });
    yield put(
      formsActions.fetchFormSuccess({
        formid,
        formInfo
      })
    );
    return formInfo;
  } catch (error) {
    yield put(formsActions.fetchFormFailure(error));
    throw error;
  }
}

export default function* formsSaga() {
  yield all([
    takeLatest(
      formsActions.fetchFormRequest.toString(),
      createAsyncSaga(fetchForm)
    )
  ]);
}
